import { getMessageFactory } from "../getCaxaWebSocket.js";
const CaseInstructions = getMessageFactory({
  code: "OPERATE_CASE"
});
export { CaseInstructions };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/caseInstructions.js